import React, { PureComponent } from 'react'
import { Button, FormCheck, OverlayTrigger, Popover } from 'react-bootstrap'

const authSchemes = ['basic', 'noauth']

const statuses = ['200', '201', '202']

class BusinessEditFormComponent extends PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      callback_authentication_scheme: '',
      callback_expected_status: '',
      callback_retry_limit: '',
      callback_url: '',
      is_callback_enabled: false,
      is_callback_paused: false,
      username: '',
      password: '',
    }
  }

  handleSelectAuthenticationScheme = (event) => this.setState({ callback_authentication_scheme: event.target.value })

  handleSelectExpectedStatus = (event) => this.setState({ callback_expected_status: event.target.value })

  handleRetryLimitChange = (event) => this.setState({ callback_retry_limit: event.target.value })

  handleCallbackUrlChange = (event) => this.setState({ callback_url: event.target.value })

  handleCallbackEnabledChange = (event) => this.setState({ is_callback_enabled: event.target.checked })

  handleCallbackPausedChange = (event) => this.setState({ is_callback_paused: event.target.checked })

  handleUsernameChange = (event) => this.setState({ username: event.target.value })

  handlePasswordChange = (event) => this.setState({ password: event.target.value })

  componentDidMount() {
    const { business } = this.props
    this.setState({
      callback_authentication_scheme: business.callback_authentication_scheme,
      callback_expected_status: business.callback_expected_status,
      callback_retry_limit: business.callback_retry_limit,
      callback_url: business.callback_url,
      is_callback_enabled: business.is_callback_enabled,
      is_callback_paused: business.is_callback_paused,
    })
  }

  handleSaveSettings = async () => {
    const { props, state } = this
    const { username, password } = state
    const credentials = JSON.stringify({ username, password })
    try {
      await props.onSave({
        callback_authentication_scheme: state.callback_authentication_scheme,
        callback_expected_status: state.callback_expected_status,
        callback_retry_limit: state.callback_retry_limit,
        callback_url: state.callback_url,
        is_callback_enabled: state.is_callback_enabled,
        is_callback_paused: state.is_callback_paused,
        callback_credentials: credentials,
      })
    } catch (e) {
      console.log(e)
    }
  }

  isRestartEnabled = () => {
    return this.props.business.is_callback_paused === false && this.props.business.is_callback_enabled === true
  }

  render() {
    const { state, props } = this
    const { isFetching, errorMessage } = props
    return (
      <div className='ibox float-e-margins animated fadeIn section-shadow'>
        <div className='ibox-content round-corner-box-bottom'>
          <form className='form-horizontal'>
            <fieldset>
              <legend>Business Settings</legend>
              {errorMessage && (
                <div className='alert alert-danger animated fadeIn m-t-md'>
                  <strong>Error</strong>: {errorMessage}
                </div>
              )}
              <div className='form-group'>
                <label className='col-md-4 control-label' htmlFor='First Name'>
                  Authentication Scheme
                </label>
                <div className='col-md-4'>
                  <div className='input-group'>
                    <select
                      value={state.callback_authentication_scheme}
                      className='form-control input-md'
                      onChange={this.handleSelectAuthenticationScheme}
                    >
                      {authSchemes.map((a, i) => (
                        <option key={i} value={a}>
                          {a}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
              </div>
              <div className='form-group'>
                <label className='col-md-4 control-label' htmlFor='Last Name'>
                  Expected Status
                </label>
                <div className='col-md-4'>
                  <div className='input-group'>
                    <select
                      value={state.callback_expected_status}
                      className='form-control input-md'
                      onChange={this.handleSelectExpectedStatus}
                    >
                      {statuses.map((a, i) => (
                        <option key={i} value={a}>
                          {a}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
              </div>
              <div className='form-group'>
                <label className='col-md-4 control-label' htmlFor='Email Address'>
                  Retry Limit Callback
                </label>
                <div className='col-md-4'>
                  <div className='input-group'>
                    <input
                      placeholder='Retry Limit Callback'
                      type={'number'}
                      className='form-control input-md'
                      disabled={isFetching}
                      onChange={this.handleRetryLimitChange}
                      value={state.callback_retry_limit}
                    />
                  </div>
                </div>
              </div>
              <div className='form-group'>
                <label className='col-md-4 control-label' htmlFor='Email Address'>
                  Callback Url
                </label>
                <div className='col-md-4'>
                  <div className='input-group'>
                    <input
                      placeholder='Callback Url'
                      className='form-control input-md'
                      disabled={isFetching}
                      onChange={this.handleCallbackUrlChange}
                      value={state.callback_url || ''}
                    />
                  </div>
                </div>
              </div>
              <div className='form-group'>
                <label className='col-md-4 control-label' htmlFor='Email Address'>
                  Callback Enabled
                </label>
                <div className='col-md-4'>
                  <div className='input-group'>
                    <FormCheck
                      defaultChecked={props.business ? props.business.is_callback_enabled : false}
                      value={state.is_callback_enabled}
                      onChange={this.handleCallbackEnabledChange}
                    />
                  </div>
                </div>
              </div>
              <div className='form-group'>
                <label className='col-md-4 control-label' htmlFor='Email Address'>
                  Callback Paused
                </label>
                <div className='col-md-4'>
                  <div className='input-group'>
                    <FormCheck
                      defaultChecked={props.business.is_callback_paused}
                      value={state.is_callback_paused}
                      onChange={this.handleCallbackPausedChange}
                    />
                  </div>
                </div>
              </div>
              <div className='form-group'>
                <label className='col-md-4 control-label' htmlFor='Email Address'>
                  Username
                </label>
                <div className='col-md-4'>
                  <div className='input-group'>
                    <input
                      placeholder='Username'
                      className='form-control input-md'
                      disabled={isFetching}
                      onChange={this.handleUsernameChange}
                      value={state.username || ''}
                    />
                  </div>
                </div>
              </div>
              <div className='form-group'>
                <label className='col-md-4 control-label' htmlFor='Email Address'>
                  Password
                </label>
                <div className='col-md-4'>
                  <div className='input-group'>
                    <input
                      placeholder='Password'
                      type={'password'}
                      className='form-control input-md'
                      disabled={isFetching}
                      onChange={this.handlePasswordChange}
                      value={state.password || ''}
                    />
                  </div>
                </div>
              </div>

              <div className='form-group'>
                <label className='col-md-4 control-label' htmlFor='Restart'>
                  Restart Paused Transactions
                </label>
                <div className='col-md-4'>
                  <div className='input-group' style={{ display: 'inline-block', cursor: 'not-allowed' }}>
                    {this.isRestartEnabled() && (
                      <Button onClick={() => props.onRestart()} className='text-center' variant={'success'}>
                        <i className='fa fa-refresh' /> Restart
                      </Button>
                    )}
                    {!this.isRestartEnabled() && (
                      <OverlayTrigger rootClose overlay={<Popover>Callbacks need to be enabled and unpaused</Popover>}>
                        <div style={{ display: 'inline-block', cursor: 'not-allowed' }}>
                          <Button
                            disabled
                            style={{ pointerEvents: 'none' }}
                            className='text-center'
                            variant={'success'}
                          >
                            <i className='fa fa-refresh' /> Restart
                          </Button>
                        </div>
                      </OverlayTrigger>
                    )}
                  </div>
                </div>
              </div>
              <div className='form-group'>
                <label className='col-md-4 control-label' />
                <div className='col-md-4'>
                  <Button onClick={props.onCancel} variant={'default'}>
                    Cancel
                  </Button>
                  <Button variant='primary' onClick={this.handleSaveSettings} disabled={isFetching}>
                    Save changes
                  </Button>
                </div>
              </div>
            </fieldset>
          </form>
        </div>
      </div>
    )
  }
}

export default BusinessEditFormComponent
